export const BenefitItem = ({
  icon,
  title,
}: {
  icon: React.ReactNode;
  title: string;
}) => {
  return (
    <div className="flex items-center gap-2 rounded-md border p-2.5 transition-colors hover:bg-muted/50">
      {icon}
      <h4 className="text-sm">{title}</h4>
    </div>
  );
};
